import { MoveRight } from "lucide-react";
import Link from "next/link";

interface FinalCTAClientProps {
  primaryButton: {
    text: string;
    url: string;
  };
  secondaryButton: {
    text: string;
    url: string;
  };
}

export default function FinalCTAClient({
  primaryButton,
  secondaryButton,
}: FinalCTAClientProps) {
  return (
    <div className="flex items-center justify-center sm:gap-x-6 gap-x-4">
      {primaryButton.text && primaryButton.url && (
        <Link
          href={primaryButton.url}
          className="max-sm:text-[12px] cta-button-primary inline-flex items-center justify-center sm:px-8 px-2 py-4 bg-accent text-white font-semibold rounded-lg hover:bg-orange-hover transition-all duration-300 transform hover:scale-105 relative overflow-hidden group"
        >
          {primaryButton.text}
        </Link>
      )}
      {secondaryButton.text && secondaryButton.url && (
        <Link
          href={secondaryButton.url}
          className="max-sm:text-[12px] font-semibold leading-6 text-white flex items-center group"
        >
          {secondaryButton.text}
          <MoveRight className="w-3 h-3 ml-2 group-hover:translate-x-1 transition-all duration-300 shrink-0" />
        </Link>
      )}
    </div>
  );
}
